import { render } from "./ISwitcher.vue?vue&type=template&id=414da9f4"
import script from "./ISwitcher.vue?vue&type=script&lang=js"
export * from "./ISwitcher.vue?vue&type=script&lang=js"

import "./ISwitcher.vue?vue&type=style&index=0&id=414da9f4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__